import type { NextPage } from 'next'

import { privacyPolicy } from 'data/seo'
import PrivacyPolicy from 'views/privacy-policy'

const PrivacyPolicyPage: NextPage = () => <PrivacyPolicy />

export default PrivacyPolicyPage

export async function getStaticProps() {
  return {
    props: { SEO: privacyPolicy }
  }
}
